import Entity from '../entity'
export default class Preferential extends Entity<number> {
    startDate: Date = null;
    endDate: Date = null;
    dateType: string = "";
    courtIds: string = '';
    creationTime: Date = new Date();
    creatorUserId: number = 0;
}